import React from "react";
import MaterialTable from "material-table";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import Auth from "../utils/Auth";

let nameClasses = error => {
  let out = "";
  error.codeLocation.forEach((item, i) => {
    if (out.length > 0) {
      out += ", ";
    }
    const pathSegments = item.path.split(/[/\\]/);
    const fileNameWithExtension = pathSegments[pathSegments.length - 1];

    const fileName = fileNameWithExtension.substring(0, fileNameWithExtension.indexOf("."));

    out += fileName;
  });
  return out;
};

export default function TableErrors({ errors, setErrorsSelected }) {
  let history = useHistory();

  const handleViewError = (data) => {
    if (Auth.isAdmin()) {
      history.push("/explorer", data);
    } else {
      history.push(`/projects/${data.projectId}/corrections/${data.date}`, data);
    }
  };

  const handleReviewedChange = (e, error) => {
    // Actualizo la tabla
    errors[errors.indexOf(error)].reviewed = e.target.value;
    let aux = [...errors];
    setErrorsSelected(aux);

    const path = {
      id: error.id,
      userId: error.userId,
      projectId: error.projectId,
      date: error.date
    };

    let url =
      process.env.REACT_APP_BASE_URL +
      "/users/" +
      path.userId +
      "/projects/" +
      path.projectId +
      "/corrections/" +
      path.date +
      "/errors/" +
      path.id;
    Axios.patch(url, {
      reviewed: e.target.value
    })
      .then(response => { })
      .catch(error => {
        console.log(error);
      });
  };

  return (
    <MaterialTable
      localization={{
        pagination: {
          labelRowsPerPage: "Filas por página",
          labelRowsSelect: "Filas",
          firstAriaLabel: "Primera página",
          firstTooltip: "Primera página",
          previousAriaLabel: "Página anterior",
          previousTooltip: "Página anterior",
          nextAriaLabel: "Próxima página",
          nextTooltip: "Próxima página",
          lastAriaLabel: "Última página",
          lastTooltip: "Última página",
        },
        toolbar: {
          nRowsSelected: "{0} filas(s) seleccionadas",
          searchTooltip: "Buscar",
          searchPlaceholder: "Buscar",
        },
        header: {
          actions: "Acciones",
        },
        body: {
          emptyDataSourceMessage: "No hay datos para mostrar",
          editRow: {
            saveTooltip: "Guardar",
            cancelTooltip: "Cancelar",
            deleteText: "¿Está seguro que lo desea eliminar?",
          },
        },
      }}
      actions={[
        {
          icon: "search",
          tooltip: "Ver en el explorador",
          onClick: (e, data) => handleViewError(data),
        },
      ]}
      title="Errores"
      columns={[
        ...(Auth.isAdmin() ? [{
          title: "Usuario",
          field: "user",
          render: rowData => `U${rowData.user.id} - ${rowData.user.name} ${rowData.user.lastName}`
        }] : []),
        { title: "Regla", field: "nameRule" },
        { title: "Proyecto", field: "nameProject" },
        {
          title: "Clase",
          field: "nameclass",
          render: (error) => nameClasses(error),
        },
        ...(Auth.isAdmin()
          ? [
            {
              title: "Estado",
              field: "reviewed",
              render: (error) => (
                <Select
                  labelId="label"
                  name="reviewed"
                  id="select"
                  onChange={(event) => handleReviewedChange(event, error)}
                  value={error.reviewed}
                  disabled
                >
                  <MenuItem key="0" value={0}>
                    No revisado
                  </MenuItem>
                  <MenuItem key="1" value={1}>
                    Falso positivo
                  </MenuItem>
                  <MenuItem key="2" value={2}>
                    Confirmado
                  </MenuItem>
                </Select>
              ),
            },
          ]
          : [{ title: "Descripcion", field: "description" }]),
      ]}
      data={errors}
      options={{
        actionsColumnIndex: -1, 
        headerStyle: {
          textAlign: "left",
          paddingLeft: '16px',
        },
        emptyRowsWhenPaging: false,
        minBodyHeight: "auto",
      }}
    />
  );
}
